import { Icon, Typography } from '@/ui';

import type { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  /** A name from this repo's `Icon` catalog, e.g. `account_box`. */
  icon: string;
}

/**
 * One icon-led metadata row in a booking page's left rail.
 *
 * MEN-3990: the Figma lays the rail out as icon + label rows
 * (file `t3BrPD8G21GljDbYsf4AXN`, node `16264:33105`), and both booking flows
 * render the same shape.
 */
export const MentoCalBookingDetailRow: FC<Props> = ({ children, icon }) => (
  <div className="flex items-center gap-4">
    <Icon className="text-xl text-cement-400">{icon}</Icon>
    <Typography className="text-sm text-cement-400">{children}</Typography>
  </div>
);
